<template>
  <div class="custom_breadcrumb">
    <a-button size="small" @click="emit('toBack')"
      ><icon-left />{{ $t("common.back") }}</a-button
    >
    <a-breadcrumb>
      <a-breadcrumb-item v-for="item in props.data">
        {{ item.label }}
      </a-breadcrumb-item>
    </a-breadcrumb>
  </div>
</template>

<script setup>
  const emit = defineEmits(["toBack"]);
  const props = defineProps({
    data: {
      type: Array,
      default: [],
    },
  });
</script>

<style lang="scss">
  .custom_breadcrumb {
    display: flex;
    align-items: center;
    & > .arco-btn {
      margin-right: 8px;
      color: var(--color_black);
      padding: 0 8px 0 4px;
    }
    .arco-breadcrumb-item {
      color: var(--color_darkgray);
      &:last-child {
        color: var(--color_black);
        font-weight: bold;
      }
    }
  }
</style>
